import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import { designOlguColumnFastMode } from "Constants/TableColumns";
import { Grid, Radio } from "@material-ui/core";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { toggleNLolayiKeshoyi } from "Constants/Constants";
import {
  getOlguListDesign,
  getGroupProfileWithTypeDesign,
} from "Stores/actions";
import {
  SAVE_ALL_OLGU_DATA_DESIGN,
  SELECTEDPROFILETYPE,
} from "Stores/actionTypes";
import { read, store } from "Helpers/LocalStorage";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTranslation } from "react-i18next";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

export default function SelectPattern({ onSelect }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    allOlguDataDesign,
    dasteProfileListWithTypeDesign,
    allOlguDataPaginationDesign,
    allOlguDataSearchDesign,
    selectedProfileType,
  } = useSelector((state) => ({
    allOlguDataDesign: state.design.allOlguDataDesign,
    allOlguDataSearchDesign: state.design.allOlguDataSearchDesign,
    allOlguDataPaginationDesign: state.design.allOlguDataPaginationDesign,
    dasteProfileListWithTypeDesign: state.design.dasteProfileListWithTypeDesign,
    selectedProfileType: state.design.selectedProfileType,
  }));
  const tblData = allOlguDataDesign || [];
  const total = allOlguDataPaginationDesign?.Total || 0;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectDasteProfileId, setSelectDasteProfileId] = useState(null);
  const [sizePerPage, setSizePerPage] = useState(3);
  const [currentPage, setCurrentPage] = useState(
    allOlguDataPaginationDesign.Page,
  );
  const [type, setType] = useState(
    selectedProfileType === 1
      ? toggleNLolayiKeshoyi[0]
      : toggleNLolayiKeshoyi[1],
  );

  const selectOptionsDasteProfile = useMemo(
    () =>
      dasteProfileListWithTypeDesign.map((item) => ({
        value: item.Id,
        label: item.Name,
      })),
    [dasteProfileListWithTypeDesign],
  );

  const selectedProfileValue = useMemo(
    () =>
      selectOptionsDasteProfile.find(
        (item) => item.value === selectDasteProfileId,
      ) || null,
    [selectOptionsDasteProfile, selectDasteProfileId],
  );

  const onGetOlguListDesign = useCallback(
    async (
      search = "",
      page = currentPage,
      profileId = selectDasteProfileId,
    ) => {
      try {
        setLoading(true);

        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: sizePerPage,
          IdGroupProfile: profileId,
          Page: page,
          ...(search
            ? {
                Name: convertToEnglishNumber(search),
              }
            : {}),
        };

        await dispatch(getOlguListDesign(params));
      } finally {
        setLoading(false);
      }
    },
    [dispatch, currentPage, selectDasteProfileId, sizePerPage],
  );

  useEffect(() => {
    if (!dasteProfileListWithTypeDesign.length) {
      dispatch({
        type: SAVE_ALL_OLGU_DATA_DESIGN,
        allOlguDataDesign: [],
        allOlguDataPaginationDesign: {
          Limit: 5,
          Page: 1,
          Total: 0,
        },
      });

      return;
    }

    const firstProfileId = dasteProfileListWithTypeDesign[0].Id;

    setSelectDasteProfileId(firstProfileId);

    onGetOlguListDesign(
      allOlguDataSearchDesign?.Name || "",
      currentPage,
      firstProfileId,
    );
  }, [dasteProfileListWithTypeDesign.length]);

  const selectRow = useMemo(
    () => ({
      mode: "radio",
      selected: selectedRow,
      clickToSelect: true,
      onSelect: (row) => {
        store("PatternDefault", row);
        setSelectedRow([row.Id]);
        onSelect(row);
      },
      classes: "selection-row",
      selectionRenderer: ({ checked, disabled }) => (
        <Radio
          className="selectRadio"
          checked={checked}
          disabled={disabled}
          color="default"
        />
      ),
    }),
    [selectedRow, onSelect],
  );

  const handleChangeDasteProfile = async (e, selectedObj) => {
    await onGetOlguListDesign(
      allOlguDataSearchDesign ? allOlguDataSearchDesign.Name : "",
      1,
      selectedObj.value,
    );

    setCurrentPage(1);
    setSelectDasteProfileId(selectedObj.value);
  };

  const onChangeToggle = async (name, key, value) => {
    setType(value);

    const IdType = value.value === "lolayi" ? 1 : 2;

    dispatch({
      type: SELECTEDPROFILETYPE,
      selectedProfileType: IdType,
    });

    try {
      setLoading(true);

      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdType,
      };

      await dispatch(getGroupProfileWithTypeDesign(params));
    } finally {
      setLoading(false);
    }
  };

  const onTableChange = async (changeType, { page, sizePerPage }) => {
    if (changeType === "pagination") {
      await onGetOlguListDesign(
        allOlguDataSearchDesign ? allOlguDataSearchDesign.Name : "",
        page,
      );

      setCurrentPage(page);
      setSizePerPage(sizePerPage);
    }
  };

  return (
    <>
      <Grid container spacing={2} className="select-pattern">
        <BackDropLoading loading={loading} />
        <Grid item xs={12} className="select-pattern-title">
          <p className="normalTitle">{t("select_olgo")}</p>
        </Grid>
        <Grid item sm={6} xs={12}>
          <MuiRadioGroup
            label={<Translator id="type" />}
            name="type"
            value={type}
            items={toggleNLolayiKeshoyi}
            onChange={onChangeToggle}
            translate={true}
            className="horizontalRadio"
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          {selectOptionsDasteProfile.length > 0 && (
            <MuiAutoComplete
              value={selectedProfileValue}
              label={<Translator id="searchProfileCategories" />}
              onChange={handleChangeDasteProfile}
              options={selectOptionsDasteProfile}
            />
          )}
        </Grid>
        <Grid xs={12}>
          <RemoteTable
            keyField="Id"
            data={tblData}
            columns={designOlguColumnFastMode}
            loading={loading}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
            title={
              read("PatternDefault") != null ? (
                `${t("isPeriod")}: ${read("PatternDefault").Name}`
              ) : (
                <Translator id="list_olgo" />
              )
            }
            selectRow={selectRow}
            sizePerPageList={[
              {
                text: "3",
                value: 3,
              },
            ]}
          />
        </Grid>
      </Grid>
    </>
  );
}
